import React from "react";
import { motion } from "framer-motion";
import ObjectiveCard from "./ObjectiveCard";

const KeyObjectives = () => {
  const objectives = [
    {
      title: "Research & Innovation",
      description: "Fund research, innovation, and technical services that drive advancements and improvements within the seed potato sector.",
      colorClass: "text-primary"
    },
    {
      title: "Industry Partnerships",
      description: "Focus on developing partnerships across the industry to support members with cutting-edge research, collaborative initiatives, and advocacy efforts.",
      colorClass: "text-secondary"
    },
    {
      title: "Advocacy",
      description: "Lobby government and governing bodies on critical issues that impact our growers, such as the regulation and use of insecticides, and quality initiatives.",
      colorClass: "text-accent"
    },
    {
      title: "Sustainable Future",
      description: "Advocate for policies that support sustainable and safe agricultural practices, ensuring the long-term viability and success of our industry.",
      colorClass: "text-muted-foreground"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <ObjectiveCard {...objectives[0]} />
            <ObjectiveCard {...objectives[1]} />
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <ObjectiveCard {...objectives[2]} />
            <ObjectiveCard {...objectives[3]} />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default KeyObjectives;